<div class="dds-modal-overlay" (click)="closeModal()"></div>

<div ddsResize class="dds-modal dds-modal_lg modalWidth">
  <div class="dds-modal__header">
    <span class="dds-modal__title"> ERROR </span>
    <dds-button
      [size]="modalCloseButtonOptions.size ?? emptyString"
      [icon]="modalCloseButtonOptions.icon ?? emptyString"
      [kind]="modalCloseButtonOptions.kind ?? emptyString"
      [theme]="modalCloseButtonOptions.theme ?? emptyString"
      [ariaLabel]="modalCloseButtonOptions.ariaLabel ?? emptyString"
      class="dds-modal__close"
      (clicked)="closeModal()"
    ></dds-button>
  </div>
  <div class="horizontal-divider-top"></div>

  <div class="dds-modal__body">
    <div>
      <div class="text-align-center margin-top-m">
        <p class="error-message">The user selected is already in the table.</p>
      </div>

      <div class="horizontal-divider"></div>
      <div class="d-flex justify-content-end padding-top-m">
        <dds-button class="custom-button" (click)="closeModal()">
          OK
        </dds-button>
      </div>
    </div>
  </div>
</div>
